import { render } from "./JerarquiaEdit.vue?vue&type=template&id=145d92be"
import script from "./JerarquiaEdit.vue?vue&type=script&lang=js"
export * from "./JerarquiaEdit.vue?vue&type=script&lang=js"

import "./JerarquiaEdit.vue?vue&type=style&index=0&id=145d92be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__